var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.066 3.711V5.63H4.658V8h1.408v7.04H9.01V8h1.983s.193-1.15.258-2.37H9.01V3.97c0-.259.322-.575.64-.575h1.6V.96H9.076c-3.074 0-3.01 2.37-3.01 2.751"
})));
export default SvgFacebook;